import React from 'react';
import '../css/VeggieInfoPopupStyling.css';
import fallbackImage from '../images/fallback/plantFallbackImage.png';

const VeggieInfoPopup = ({ veggie, gardenInfo, onClose }) => {
    if (!veggie) return null;

    function getCompatibilityScores(veggie, garden) {
        return {
            soil: veggie.soil_type.includes(garden.soilType) ? 1 : 0,
            sunlight: veggie.sunlight === garden.sunlight ? 1 : 0,
            water: (garden.maintenance === 'Low' && veggie.water_needs === 'Xeric')
            || (garden.maintenance === 'Medium' && veggie.water_needs === 'Mesic')
            || (garden.maintenance === 'High' && veggie.water_needs === 'Hydric')
                ? 1 : 0,
            zone: Array.isArray(veggie.hardiness_zones) && veggie.hardiness_zones.includes(garden.hardiness) ? 1 : 0,
            temperature: veggie.temperature_min <= 65 && veggie.temperature_max >= 75 ? 1 : 0
        };
    }

    const scores = getCompatibilityScores(veggie, gardenInfo);
    const total = Object.values(scores).reduce((a, b) => a + b, 0);
    const compatibilityPercentage = Math.round((total / 5) * 100);

    return (
        <div className="popup-overlay" onClick={onClose}>
            <div className="popup-content" onClick={(e) => e.stopPropagation()}>
                <div className={"veggie-popup-header"}>
                    <div className={"veggie-popup-header-icon"}>
                        <img
                            src={veggie.plant_image_url || fallbackImage}
                            alt={veggie.plant_name}
                            className="popup-image"
                        />
                    </div>

                    <div className={"veggie-popup-header-text"}>
                        <h2>{veggie.plant_name}</h2>
                        <div className="veggie-tags">
                            {veggie.tags.map((tag, index) => (
                                <span key={tag + index} className="tag">{tag}</span>
                            ))}
                        </div>
                        <h3><i>{veggie.scientific_name || 'No scientific name available'}</i></h3>
                        <h4>Type: {veggie.plant_type} &mdash; {veggie.crop_type}</h4>
                        <h4> Lifecycle: {veggie.lifecycle}</h4>
                    </div>
                </div>

                <p>{veggie.short_description || 'No description available.'}</p>

                <div className="veggie-info">
                    <div className={"popup-left-side"}>
                        <h3>Growing Requirements</h3>
                        <div className={"popup-left-side-items"}>
                            <h4>&bull; Sunlight: {veggie.sunlight}</h4>
                            <h4>&bull; Soil Type: {veggie.soil_type.join(', ')}</h4>
                            <h4>&bull; Soil pH: {veggie.soil_ph}</h4>
                            <h4>&bull; Water Needs: {veggie.water_needs}</h4>
                            <h4>&bull; Hardiness Zones: {veggie.hardiness_range}</h4>
                            <h4>&bull; Temperature
                                Range: {veggie.temperature_min}&deg; F &mdash; {veggie.temperature_max}&deg; F</h4>
                        </div>
                    </div>

                    <div className={"popup-right-side"}>
                        <h3>Planting Info</h3>
                        <div className={"popup-right-side-items"}>
                            <h4>&bull; Days to Maturity: {veggie.days_to_maturity}</h4>
                            <h4>&bull; Planting Seasons: {veggie.planting_season.join(', ')}</h4>
                            <h4>&bull; {veggie.start_indoors} to start indoors</h4>
                            <h4>&bull; Transplant: {veggie.transplant_time}</h4>
                            <h4>&bull; Mature Height: {veggie.mature_height}</h4>
                            <h4>&bull; Mature Width: {veggie.mature_width}</h4>
                        </div>
                    </div>
                </div>

                <div className="companion-plants">
                    <h3>Companion Plants</h3>
                    <h4>&bull; {veggie.companion_plants.join(',  ')}</h4>
                </div>

                <div className="avoid-plants">
                    <h3>Avoid Plants</h3>
                    <h4>&bull; {veggie.avoid_plants.join(',  ')}</h4>
                </div>

                <div className="popup-veggie-compatability-bar">
                    <h3>Garden Compatibility</h3>
                    <div className="compatibility-progress-container">
                        <div className="compatibility-progress-bar" title={"We recommend to choose plants with higher than 40% compatability; Plants are versatile!"}>
                            <div
                                className="compatibility-progress-fill"
                                style={{width: `${compatibilityPercentage}%`}}
                            >
                                <span className="compatibility-progress-text">
                                    {compatibilityPercentage}%
                                </span>
                            </div>
                        </div>
                        <div className="compatibility-details">
                            {Object.entries(scores).map(([category, score]) => (
                                <div
                                    key={category}
                                    className={`compatibility-badge ${score === 1 ? 'compatible' : 'incompatible'}`}
                                    title={`${category}: ${score === 1 ? 'Compatible' : 'Not Compatible'}`}
                                >
                                    {score === 1 ? '✓' : '✗'} {category}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className={"popup-bottom-buttons"}>
                    <a href={veggie.amazon_purchase_link || '#'} target="_blank" rel="noreferrer">
                        Buy Seeds
                    </a>
                    <button onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default VeggieInfoPopup;
